export const classes = {
  bar: 'sticky inset-x-0 bottom-0 z-50 hidden items-center justify-between gap-4 border-t border-frame-border bg-headerbg px-[18px] pb-[calc(10px+env(safe-area-inset-bottom))] pt-2.5 backdrop-blur-[24px] transition-transform duration-300 ease-out max-lg:flex dark:border-frame-border-dark dark:bg-headerbg-dark',
  barHidden: 'translate-y-full',
  totalLabel: 'text-[11px] font-semibold text-taupe-1 dark:text-mauve-3',
  total:
    'text-lg font-extrabold tracking-[-0.02em] text-taupe-3 dark:text-mauve-1',
  cta: 'min-w-[132px]',
};
